<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Étkezés</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$ && sajatIntezmeny"><br>
  <ng-container *ngIf="userMetadata">
    <!-- Nézetváltó: kis kijelzőn a lista-nézet nyílik, de mindkettő bármikor választható.
         Fókuszban (body.sulinform-fokusz) a váltó és a Napi hiányzók gomb egy sorban, fehér sávban. -->
    <div class="e-nezetsor">
    <ion-segment [(ngModel)]="aloldal" style="max-width:420px;margin:0 auto">
      <ion-segment-button value="1">
        <ion-label>Lista</ion-label>
        <ion-icon name="list-outline"></ion-icon>
      </ion-segment-button>
      <ion-segment-button value="2">
        <ion-label>Táblázat</ion-label>
        <ion-icon name="grid-outline"></ion-icon>
      </ion-segment-button>
    </ion-segment>
    <!--  NAPI HIÁNYZÓK (#1070): aki ebédeltet, itt nézi meg dátum szerint, hogy az aznapra
          ebédet rendeltek közül ki hiányzik – reggel óta hiányzó ebédje kiadható. -->
    <div class="e-hianyzok" style="text-align:center;margin-top:8px" *ngIf="loginMode=='dolgozo'">
      <ion-button size="small" color="warning" (click)="napiHianyzokNyitva = true">
        <ion-icon slot="start" name="person-remove-outline"></ion-icon>Napi hiányzók (ebéd)
      </ion-button>
    </div>
    </div>
    <ion-modal [isOpen]="napiHianyzokNyitva" (didDismiss)="napiHianyzokNyitva = false"
               style="--width:min(1000px,96vw);--height:90vh">
      <ng-template>
        <ion-header>
          <ion-toolbar>
            <ion-title>Napi hiányzók (ebéd)</ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="napiHianyzokNyitva = false">Bezár</ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
          <app-etkezes-napi-hianyzok [intezmeny]="sajatIntezmeny?.intezmenyId"></app-etkezes-napi-hianyzok>
        </ion-content>
      </ng-template>
    </ion-modal>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-card style="height: 100%">
            <ion-card-header>
              <ion-card-title>Beállítások</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-input label="Tárgyév" type="text" fill="outline" labelPlacement="stacked" placeholder="2023"
                      [(ngModel)]="selectedYearS"></ion-input>
                  </ion-col>
                  <!--ion-col>
                    <ion-item *ngIf="selectedMonth">
                      <label for="selectedMonth">Tárgyhónap:&nbsp;</label>
                      <select style="min-height: 56px; border: 0; cursor: pointer"
                              name="selectedMonth" fill="outline" labelPlacement="stacked"
                              [(ngModel)]="selectedMonthS"
                      >
                        <option value="1">Január</option>
                        <option value="2">Február</option>
                        <option value="3">Március</option>
                        <option value="4">Április</option>
                        <option value="5">Május</option>
                        <option value="6">Június</option>
                        <option value="7">Július</option>
                        <option value="8">Augusztus</option>
                        <option value="9">Szeptember</option>
                        <option value="10">Október</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                    </ion-item>
                  </ion-col-->
                  <ion-col *ngIf="selectedMonth && selectedMonthS">
                    <!--ion-item *ngIf="selectedMonth"-->
                    <!--label>Tárgyhónap:&nbsp;</label-->
                    <ion-select fill="outline" interface="popover" label="Tárgyhónap" labelPlacement="stacked"
                      name="selectedMonth" [(ngModel)]="selectedMonthS"
                      [value]="selectedMonthS"><!-- style="min-height: 56px; border: 0; cursor: pointer"-->
                      <ion-select-option value="1">Január</ion-select-option>
                      <ion-select-option value="2">Február</ion-select-option>
                      <ion-select-option value="3">Március</ion-select-option>
                      <ion-select-option value="4">Április</ion-select-option>
                      <ion-select-option value="5">Május</ion-select-option>
                      <ion-select-option value="6">Június</ion-select-option>
                      <ion-select-option value="7">Július</ion-select-option>
                      <ion-select-option value="8">Augusztus</ion-select-option>
                      <ion-select-option value="9">Szeptember</ion-select-option>
                      <ion-select-option value="10">Október</ion-select-option>
                      <ion-select-option value="11">November</ion-select-option>
                      <ion-select-option value="12">December</ion-select-option>
                    </ion-select>
                    <!--/ion-item-->
                  </ion-col>
                </ion-row><ion-row>
                  <ion-col *ngIf="intezmenyek">

                    <ion-input label="Intézmény" readonly fill="outline" labelPlacement="stacked" type="text"
                      placeholder="Válasszon intézményt" [value]="sajatIntezmeny.intezmenyName"></ion-input>

                  </ion-col>
                  <!--ion-col>
                  <ion-item>
                    <ion-toggle justify="start">Munkavállaló / Tanuló</ion-toggle>
                  </ion-item>
                </ion-col-->
                </ion-row>

                <ion-button (click)="searchM()">
                  <ion-icon slot="start" name="search"></ion-icon>
                  Keresés
                </ion-button>
                <ion-button color="secondary" (click)="resetM()">
                  <ion-icon slot="start" name="refresh"></ion-icon>
                  Visszaállítás
                </ion-button>

              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <!--  HETI ÉTLAP: mi van az „A” és a „B” mögött. Csak ha az intézmény feltölt étlapot
          (Admin → Étkezés → Étlap) – különben a panel meg sem jelenik. -->
    <div class="e-etlap">
      <app-etlap-heti [intezmeny]="sajatIntezmeny.intezmenyId" [rejtUresen]="true"></app-etlap-heti>
    </div>

    <ion-grid>
      <ion-row>
        <!-- LISTA (mobil) NÉZET: a hónap napjai egymás alatt, modál nélkül. Napi
             menüválasztásnál a napok mellett a menük sorszáma választható. -->
        <ion-col *ngIf="aloldal == '1'">
          <ion-card>
            <ion-card-content>
              <ion-item lines="none" *ngIf="ports?.length > 1">
                <ion-select label="Étkező" labelPlacement="stacked" interface="popover" [(ngModel)]="mobilUserKey">
                  <ion-select-option *ngFor="let p of ports" [value]="getEtkezesUserKey(p)">
                    {{p.viselt_vez}} {{p.viselt_ker}}
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <ng-container *ngIf="mobilUser as u">
                <div class="mobil-fejlec">
                  <div><b>{{u.viselt_vez}} {{u.viselt_ker}}</b></div>
                  <div class="mobil-osszeg">{{u.osszeg || 0}}</div>
                </div>

                <ng-container *ngIf="!u.aktiv">
                  <ion-note color="danger" style="display:block;margin:8px 0">
                    Nincs rögzített étkezési belépés, ezért nem lehet napot rendelni.
                  </ion-note>
                  <ion-button size="small" (click)="megnyitIdoszak(u)">
                    <ion-icon slot="start" name="log-in-outline"></ion-icon>Be/kilépés rögzítése
                  </ion-button>
                </ng-container>

                <ng-container *ngIf="u.aktiv">
                  <ion-item lines="none" *ngIf="u.beszallitok?.length > 1">
                    <ion-select label="Beszállító" labelPlacement="stacked" interface="popover"
                      [ngModel]="u.selectedHely" (ngModelChange)="setSelectedHely(u, $event)">
                      <ion-select-option *ngFor="let b of u.beszallitok" [value]="b.id">{{b.nev}}</ion-select-option>
                    </ion-select>
                  </ion-item>
                  <!--  Napi módban itt sincs menüválasztó: a napok sorában lévő jelölők
                        döntenek, egy fölöttük álló második választó csak zavarna. -->
                  <ion-item lines="none" *ngIf="u.menuk?.length > 1 && !napiMenu">
                    <ion-select label="Menü" labelPlacement="stacked" interface="popover"
                      [ngModel]="u.selectedMenu" (ngModelChange)="setSelectedMenu(u, $event)">
                      <ion-select-option *ngFor="let m of u.menuk" [value]="m.id">
                        {{m.nev}} ({{m.ar}} Ft)
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                  <ion-note color="medium" *ngIf="u.menuk?.length > 1 && napiMenu"
                            style="display:block;font-size:12px;margin:4px 0 8px">
                    A menüt naponta választod – koppints a nap melletti jelölőre.
                    <span *ngFor="let m of u.menuk"><br><b>{{menuCimke(u, m.id)}}</b> = {{m.nev}} ({{m.ar}} Ft)</span>
                  </ion-note>
                  <ion-note color="medium" *ngIf="u.menuk?.length == 1" style="display:block;margin:4px 0 8px">
                    {{u.menuk[0].nev}} ({{u.menuk[0].ar}} Ft)
                  </ion-note>

                  <div class="mobil-gombok">
                    <ion-button size="small" color="secondary" (click)="tomegesKer(u, -1, 1)">Összes nap</ion-button>
                    <ion-button size="small" color="medium" fill="outline" (click)="tomegesKer(u, -1, 0)">Lemondás</ion-button>
                    <ion-button size="small" color="success" (click)="saveData()">
                      <ion-icon slot="start" name="cloud-upload"></ion-icon>Mentés
                    </ion-button>
                    <ion-button size="small" fill="outline" color="medium" (click)="megnyitIdoszak(u)">Be/kilépés</ion-button>
                  </div>

                  <ion-list [inset]="true">
                    <!-- A NAP SORA maga a kapcsoló: koppintásra kér / lemond (a pipálandó
                         doboz mobilon túl kicsi volt, és az ion-item [class] kötése az Ionic
                         saját osztályait is felülírta). Napi menüválasztásnál a sor nem
                         kattintható, mert ott a menü-sorszámok döntenek. -->
                    <ion-item *ngFor="let nap of daysInMonth; let idx = index"
                      [ngClass]="'nap-' + napAllapot(u, idx)"
                      [button]="napValthato(u, idx)" detail="false"
                      (click)="napValthato(u, idx) && napValt(u, idx)">
                      <ion-label>
                        <strong>{{nap.dayNumber}}.</strong> {{nap.dayName}}
                        <br>
                        <ion-note color="medium" style="font-size:12px">
                          <span *ngIf="napKert(u, idx)">{{napMenuNeve(u, u.adatok[idx].menu) || 'menü nélkül'}}</span>
                          <span *ngIf="napAllapot(u, idx) == 'nem'">nem kér</span>
                          <span *ngIf="napAllapot(u, idx) == 'szamlazott'"> · számlázva</span>
                          <span *ngIf="napAllapot(u, idx) == 'kivul'">étkezési időszakon kívül</span>
                          <span *ngIf="napAllapot(u, idx) == 'program'">{{u.adatok[idx].zar_ok}} – az ebéd lemondva</span>
                          <span *ngIf="napAllapot(u, idx) == 'hetvege'">–</span>
                          <span *ngIf="napZart(u, idx)"> · határidőn túl</span>
                        </ion-note>
                        <!-- Az étlap: kért napon a kért menü étele, egyébként a nap menüi. -->
                        <div class="e-etel" *ngIf="napAllapot(u, idx) != 'hetvege' && napEtelSzoveg(u, idx) as etel">
                          <ion-icon name="restaurant-outline"></ion-icon>{{etel}}
                        </div>
                      </ion-label>

                      <!-- Napi menüválasztás: a menük sorszámai koppintásra váltanak. -->
                      <div slot="end" *ngIf="napiCella(u, idx)" class="mobil-menuk">
                        <ion-chip *ngFor="let m of u.menuk"
                          [outline]="napMenuErtek(u, idx) != m.id" color="success"
                          (click)="napMenuValaszt(u, idx, m.id)" [title]="m.nev + ' (' + m.ar + ' Ft)' + napMenuEtelUtotag(u, idx, m.id)">
                          {{menuCimke(u, m.id)}}
                        </ion-chip>
                        <ion-chip [outline]="!napKert(u, idx)" color="medium" (click)="napMenuValaszt(u, idx, '')">–</ion-chip>
                      </div>

                      <!-- Egy menü vagy havi mód: a sor állapotjelzője. -->
                      <ion-icon slot="end" *ngIf="napValthato(u, idx)" size="large"
                        [name]="napKert(u, idx) ? 'checkmark-circle' : 'ellipse-outline'"
                        [color]="napKert(u, idx) ? 'success' : 'medium'"></ion-icon>
                      <ion-icon slot="end" *ngIf="napAllapot(u, idx) == 'szamlazott'" name="lock-closed-outline"
                        color="medium"></ion-icon>
                      <ion-icon slot="end" *ngIf="napAllapot(u, idx) == 'program'" name="bus-outline"
                        color="warning" [title]="u.adatok[idx].zar_ok"></ion-icon>
                    </ion-item>
                  </ion-list>
                </ng-container>
              </ng-container>
              <ion-note color="medium" *ngIf="osztalyVarakozik">Válassz osztályt a névsor betöltéséhez.</ion-note>
              <ion-note color="medium" *ngIf="!osztalyVarakozik && !ports?.length">Nincs megjeleníthető étkező.</ion-note>
            </ion-card-content>
          </ion-card>
        </ion-col>
        <ion-col *ngIf="aloldal == '2'">
          <ion-card>
            <ion-card-header>
              <ion-card-title>Étkezés összesítő<ion-button (click)="saveData()" style="float:right;" color="light">
                  <ion-icon slot="start" name="cloud-upload"></ion-icon>Mentés
                </ion-button><ion-button (click)="printData()" style="float:right" color="secondary">
                  <ion-icon slot="icon-only" name="print-outline"></ion-icon>
                </ion-button><ion-button (click)="saveDataElotolt()" style="float:right" color="danger" *ngIf="loginMode=='dolgozo' && elotoltesEngedve">
                  <ion-icon slot="start" name="cloud-upload"></ion-icon>Előtöltés
                </ion-button></ion-card-title>
            </ion-card-header>

            <ion-card-content>

<!--  NÉVSOR-VEZÉRLŐK egy sorban: kit töltünk be, és abból mit mutatunk.
                    A kettő külön kérdés – az első a kiszolgálót terheli, a második csak a
                    szemet –, ezért látszik mindkettő. -->
              <div class="nevsor-vezerlok" *ngIf="loginMode=='dolgozo'">
                <ng-select (change)="EtkezesSzuro($event)" appendTo="body" [notFoundText]="'Nincs találat'"
                              [items]="osztaly" placeholder="Osztály"
                              [(ngModel)]="valasztottOsztaly" [ngModelOptions]="{standalone: true}"
                              bindValue="id" [multiple]="false" [closeOnSelect]="true"
                              bindLabel="osztaly" class="osztaly-valaszto">
                </ng-select>
                <ion-button size="small" fill="outline" (click)="osszesTanulo()"
                            title="Az intézmény összes étkezője – több száz tanulónál lassabb betöltés">
                  <ion-icon slot="start" name="people-outline"></ion-icon>Összes tanuló
                </ion-button>
                <!--  A szűrő a MEGJELENÍTÉST szűkíti, az adatot nem: a hónap közepén a
                      névsor nagyobbik fele jellemzően egyetlen napot sem kért, és köztük
                      kell megtalálni azt a párat, akinél változott valami. -->
                <ion-item lines="none" class="kerok-szuro" *ngIf="ports?.length">
                  <ion-toggle [(ngModel)]="csakKerok" [ngModelOptions]="{standalone: true}"
                              justify="start" labelPlacement="end">
                    Csak aki kért
                  </ion-toggle>
                </ion-item>
              </div>
              <!-- A névsor osztályonként töltődik: több száz tanulónál az egész iskola
                   egyszerre másodpercekig tartó lekérdezés. -->
              <ion-note color="medium" *ngIf="osztalyVarakozik" style="display:block;margin:12px 5px;">
                Válassz osztályt a névsor betöltéséhez, vagy kérd az <b>Összes tanulót</b> —
                több száz tanulónál az utóbbi lassú.
              </ion-note>
              <!--  Ha a szűrő elrejt valakit, azt KIMONDJUK: enélkül úgy tűnne, hiányzik
                    valaki a névsorból. -->
              <ion-note color="medium" *ngIf="csakKerok && elrejtettDb" style="display:block;margin:0 5px 8px">
                {{elrejtettDb}} olyan étkező rejtve, aki ebben a hónapban egyetlen napot sem kért.
              </ion-note>
              <!--a-- href="javascript:void(0);" (click)="printUrl('/print?minimize=1')">nyomtatás</a-->
              <!--a href="javascript:void(0);" (click)="printData()">nyomtatás</a>
    <b>FEJLESZTÉS ALATT, ALPHA VÁLTOZAT</b-->
              <div class="scrollable-table printable">
                <table id="printable" *ngIf="daysInMonth && lathatoPortok.length && !osztalyVarakozik" style="width: 100%;">
                  <thead>
                    <tr>
                      <!--th>#</th-->
                      <th>Személy</th>
                      <!-- A nap címében az étlap (egérrel ráállva): mi van aznap menünként. -->
                      <th *ngFor="let c of [].constructor(daysInMonth.length); let idx = index"
                        [title]="napEtlapOsszes(idx, '\n')" [class.van-etlap]="!!napEtlapOsszes(idx)">{{("0" +
                        (idx+1)).slice(-2)}}</th>
                      <th>{{replaceAccentedChars("Beszállító / menü")}}</th>
                      <th>{{replaceAccentedChars("∑(Ft)")}}</th>
                      <th>{{replaceAccentedChars("Műveletek")}}</th>
                      <!--th>{{replaceAccentedChars("Ár felülírása")}}</th-->
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->

                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let user of lathatoPortok; let i = index">
                      <!-- Nincs rögzített étkezési belépés → a sor szürke, csak a be/kilépés érhető el. -->
                      <tr *ngIf="!user.aktiv" class="nincs-belepes">
                        <td>{{replaceAccentedChars(user.viselt_vez)}} {{replaceAccentedChars(user.viselt_ker)}}</td>
                        <ng-container *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">
                          <td style="background-color:lightgray;text-align: center">
                            &nbsp;&nbsp;
                          </td>
                        </ng-container>
                        <td style="background-color:lightgray;text-align: center">
                          <small>Nincs bejelentkezés</small>
                        </td>
                        <td style="background-color:lightgray;text-align: center">
                          &nbsp;&nbsp;
                        </td>
                        <td style="background-color:lightgray;text-align: center">
                          <ion-button size="small" fill="outline" color="medium" (click)="megnyitIdoszak(user)">
                            Be/kilépés
                          </ion-button>
                        </td>
                      </tr>
                      <tr *ngIf="user.aktiv">
                        <td>{{replaceAccentedChars(user.viselt_vez)}} {{replaceAccentedChars(user.viselt_ker)}}</td>

                        <ng-container *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">
                          <!-- NAPI menüválasztás: a cellában a menü sorszáma áll a pipa helyett,
                               és naponta átváltható. Csak akkor, ha az intézmény napi módban van
                               és a diáknak több menü közül lehet választani. -->
                          <td *ngIf="napiCella(user, idx)" name="checkmark"
                            [style.background-color]="user.adatok[idx].value==1 ? '#e6ffe6' : '#FFF5EE'"
                            style="text-align:center;padding:1px">
                            <span class="nyomtatott-ertek">{{napiMenuSzam(user, idx)}}</span>
                            <select class="napi-menu" [ngModel]="napMenuErtek(user, idx)"
                              (ngModelChange)="napMenuValaszt(user, idx, $event)"
                              [title]="napMenuNeve(user, user.adatok[idx].menu) + napMenuEtelUtotag(user, idx, user.adatok[idx].menu)">
                              <option value="">–</option>
                              <option *ngFor="let m of user.menuk" [value]="m.id"
                                [title]="m.nev + ' (' + m.ar + ' Ft)' + napMenuEtelUtotag(user, idx, m.id)">{{menuCimke(user, m.id)}}</option>
                            </select>
                          </td>
                          <td [ngClass]="{'selected': isSelected(i, idx)}" (mousedown)="startSelection(i, idx)"
                            (mouseenter)="dragSelection(i, idx)" (mouseup)="endSelection()"
                            (click)="changeKer(user, idx,1)" *ngIf="user.adatok[idx].value==0 && !napiCella(user, idx)" name="close"
                            style="background-color:#FFF5EE;text-align: center;cursor:pointer">
                            <ion-icon name="close-outline"></ion-icon>
                          </td>
                          <td (click)="changeKer(user, idx,0)"
                            *ngIf="user.adatok[idx].tranzakcio==0 && user.adatok[idx].value==1 && !napiCella(user, idx)" name="checkmark"
                            style="background-color:#e6ffe6;text-align: center;cursor:pointer">
                            <ion-icon name="checkmark-outline"></ion-icon>
                          </td>
                          <td *ngIf="user.adatok[idx].tranzakcio==1 && user.adatok[idx].value==1" name="checkmark"
                            style="background-color:#b5feb5;text-align: center">
                            <ion-icon name="checkmark-done-outline"></ion-icon>
                          </td>
                          <td *ngIf="user.adatok[idx].tranzakcio==2 && user.adatok[idx].value==1" name="checkmark"
                            style="background-color:#f1fff4;text-align: center">
                            <ion-icon name="hourglass"></ion-icon>
                          </td>
                          <td *ngIf="user.adatok[idx].value==-1" style="background-color:lightgray;text-align: center">
                            &nbsp;&nbsp;
                          </td>
                          <td *ngIf="user.adatok[idx].value==-2"
                            style="background-color:#dcdcdc;text-align: center;color:#999"
                            title="Étkezési időszakon kívül">
                            <ion-icon name="remove-outline"></ion-icon>
                          </td>
                          <!-- Iskolai program miatt lemondott, zárolt nap: nem kérhető újra. -->
                          <td *ngIf="user.adatok[idx].value==-3" class="program-zarolt"
                            style="background-color:#fff3cd;text-align: center;color:#8a6d3b"
                            [title]="user.adatok[idx].zar_ok + ' – az ebéd lemondva, nem kérhető újra'">
                            <ion-icon name="bus-outline"></ion-icon>
                          </td>
                        </ng-container>
                        <td class="beszallito-cella">
                          <!-- Beszállító és menü: a szülő is válthat; a váltás a még
                               módosítható napokra érvényes, a leadottakra nem. -->
                          <select *ngIf="user.beszallitok?.length > 1" [ngModel]="user.selectedHely"
                            (ngModelChange)="setSelectedHely(user, $event)" style="max-width:160px;font-size:12px">
                            <option *ngFor="let b of user.beszallitok" [value]="b.id">{{b.nev}}</option>
                          </select>
                          <span *ngIf="!(user.beszallitok?.length > 1)">{{helyNeve(user, user.selectedHely)}}</span>

                          <div style="margin-top:4px">
                            <!--  NAPI MÓDBAN NINCS MENÜVÁLASZTÓ EBBEN AZ OSZLOPBAN.
                                  A menüt ott választják, ahol tartozik valamihez: a nap
                                  cellájában. Egy második, sor szintű választó ugyanarra a
                                  kérdésre adott volna másik választ – és mivel a napi
                                  cellák felülírják, csak félreérthető lett volna. Havi
                                  módban viszont EZ a választó dönt, ott marad. -->
                            <select *ngIf="user.menuk?.length > 1 && !napiMenu" [ngModel]="user.selectedMenu"
                              (ngModelChange)="setSelectedMenu(user, $event)" style="max-width:160px;font-size:12px">
                              <option *ngFor="let m of user.menuk" [value]="m.id">{{m.nev}} ({{m.ar}} Ft)</option>
                            </select>
                            <small *ngIf="user.menuk?.length == 1">{{user.menuk[0].nev}} ({{user.menuk[0].ar}} Ft)</small>
                            <small *ngIf="!user.menuk?.length" style="color:#c00">Nincs menü</small>
                          </div>
                          <!--  A napi cellákban a menü rövid JELE áll (egy hónap 31 oszlop, oda a
                                név nem fér ki). Napi módban ez a lista az egyetlen hely, ahol a
                                menü teljes neve és ÁRA látszik – ezért ott mindig kiírjuk.
                                Havi módban csak akkor, ha a jel nem maga a menü neve. -->
                          <div *ngIf="napiMenu && user.menuk?.length > 1"
                               style="margin-top:4px;font-size:11px;color:#555">
                            <div *ngFor="let m of user.menuk"><b>{{menuCimke(user, m.id)}}</b> = {{m.nev}} ({{m.ar}} Ft)</div>
                          </div>
                          <div style="margin-top:4px">
                            <ion-button size="small" fill="outline" color="medium" (click)="megnyitIdoszak(user)">
                              Be/kilépés
                            </ion-button>
                          </div>
                        </td>
                        <td class="rotate1">
                          {{user.osszeg || 0}}
                        </td>
                        <td class="rotate1">
                          <ion-button (click)="tomegesKer(user, -1, 1)" color="secondary" size="small">
                            Összes
                          </ion-button>
                        </td>
                        <!--td>
                        <input type="number">
                      </td-->
                      </tr>

                    </ng-container>

                    <tr>
                      <!--th>#</th-->
                      <th>Személy</th>
                      <th *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">{{("0" +
                        (idx+1)).slice(-2)}}</th>
                      <th colspan="3">-</th>
                      <!--th>{{replaceAccentedChars("Ár felülírása")}}</th-->
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->

                    </tr>
                    <tr>
                      <td>Napi összes (db)</td>

                      <!-- Csak a naptár dönti el, melyik nap szürke: az első sor diákjának
                           állapota nem az egész iskoláé (lehet, hogy ő be sem lépett). -->
                      <ng-container *ngFor="let c of daysInMonth; let idx = index">
                        <td *ngIf="c.isWeekend || c.isHoliday" style="background-color:lightgray;text-align: center;">
                          &nbsp;&nbsp;
                        </td>
                        <td *ngIf="!c.isWeekend && !c.isHoliday" style="text-align: center;">
                          {{osszegzes[idx]}}
                        </td>
                      </ng-container>
                      <td style="background-color:lightgray;text-align: center;" colspan="3">
                        &nbsp;&nbsp;
                      </td>
                    </tr>

                    <!-- Menünkénti napi bontás: a beszállítónak menünként kell leadni a
                         rendelést, egy összesített darabszámból az nem jön ki. Csak azok a
                         menük jelennek meg, amelyeket a hónapban ténylegesen választottak. -->
                    <tr *ngFor="let mo of menuOsszegzes" class="menu-bontas">
                      <td style="padding-left:16px;font-size:0.92em;">{{ mo.nev }}</td>
                      <ng-container *ngFor="let c of daysInMonth; let idx = index">
                        <td *ngIf="c.isWeekend || c.isHoliday" style="background-color:lightgray;text-align:center;">
                          &nbsp;&nbsp;
                        </td>
                        <td *ngIf="!c.isWeekend && !c.isHoliday" style="text-align:center;font-size:0.92em;">
                          {{ mo.napok[idx] || '' }}
                        </td>
                      </ng-container>
                      <td style="background-color:lightgray;text-align:center;" colspan="3">
                        &nbsp;&nbsp;
                      </td>
                    </tr>

                    <tr>
                      <!--th>#</th-->
                      <th>Beszállító</th>
                      <th *ngFor="let c of [].constructor(daysInMonth.length); let idx = index">{{("0" +
                        (idx+1)).slice(-2)}}</th>
                      <th colspan="3">-</th>
                      <!--th>{{replaceAccentedChars("Ár felülírása")}}</th-->
                      <!--th><ion-icon name="bed-outline"></ion-icon></th-->

                    </tr>
                  </tbody>

                </table>
                <!--  ÜRES TÁBLÁZAT: mondjuk meg, MIÉRT. A szűrő bekapcsolva és senki nem
                      kért – ez más helyzet, mint ha a névsor lenne üres. -->
                <ion-note color="medium" *ngIf="!osztalyVarakozik && ports?.length && !lathatoPortok.length"
                          style="display:block;margin:12px 5px">
                  Ebben a hónapban egyetlen betöltött étkező sem kért napot. Kapcsold ki a
                  <b>„Csak aki kért"</b> szűrőt a teljes névsorhoz.
                </ion-note>
                <ion-note color="medium" *ngIf="!osztalyVarakozik && !ports?.length"
                          style="display:block;margin:12px 5px">
                  Nincs megjeleníthető étkező.
                </ion-note>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <!-- Étkezési be-/kilépés modal -->
  <ion-modal [isOpen]="!!idoszakUser" (didDismiss)="bezarIdoszak()">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Étkezési be-/kilépés</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="bezarIdoszak()">Bezár</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding" *ngIf="idoszakUser">
        <h3 style="margin-top:0">{{idoszakUser.viselt_vez}} {{idoszakUser.viselt_ker}}</h3>

        <ion-list *ngIf="idoszakUser.idoszakok?.length">
          <ion-list-header>Korábbi időszakok</ion-list-header>
          <ion-item *ngFor="let p of idoszakUser.idoszakok">
            <ion-label>
              {{ p.kezdet ? (p.kezdet | date:'yyyy.MM.dd') : '?' }} –
              {{ p.vege ? (p.vege | date:'yyyy.MM.dd') : 'folyamatban' }}
              <br><small style="color:var(--ion-color-medium)">{{ helyNeve(idoszakUser, p.hely) || 'nincs beszállító' }}</small>
            </ion-label>
            <ion-button slot="end" fill="clear" color="danger" (click)="torolIdoszak(p.id)">
              <ion-icon slot="icon-only" name="trash"></ion-icon>
            </ion-button>
          </ion-item>
        </ion-list>
        <ion-note color="medium" *ngIf="!idoszakUser.idoszakok?.length" style="display:block;margin:8px 0">
          Még nincs rögzített étkezési belépés, ezért a diák nem étkezik. A belépés
          rögzítésével indul az étkezés – ettől a naptól lehet napokat rendelni.
        </ion-note>

        <ion-item>
          <ion-label position="stacked">Dátum</ion-label>
          <ion-input type="date" [(ngModel)]="idoszakDatum"></ion-input>
        </ion-item>

        <!--  A BELÉPÉS AZT RÖGZÍTI, HOGY A DIÁK ÉTKEZIK – nem azt, hogy mit eszik.
              A menüt a nap hordozza (napi módban naponta, haviban a hónap választója),
              ezért itt nem kérdezzük: a belépéskor úgysem tudni, mit kér majd júniusban.
              A beszállító viszont valódi döntés – de csak ott, ahol több is van.  -->
        <ion-item *ngIf="idoszakUser.beszallitok?.length > 1">
          <ion-label position="stacked">Beszállító</ion-label>
          <ion-select interface="popover" [ngModel]="idoszakUser.selectedHely"
            (ngModelChange)="valasztHely(idoszakUser, $event)" placeholder="Válassz beszállítót">
            <ion-select-option *ngFor="let b of idoszakUser.beszallitok" [value]="b.id">{{b.nev}}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-note color="medium" *ngIf="idoszakUser.beszallitok?.length == 1" style="display:block;margin:8px 0">
          Beszállító: <b>{{idoszakUser.beszallitok[0].nev}}</b> – az intézménynek egy beszállítója van,
          nincs miből választani.
        </ion-note>
        <ion-note color="danger" *ngIf="!idoszakUser.menuk?.length" style="display:block;margin:8px 0">
          A beszállítóhoz nincs menü rögzítve (Admin → Étkezés → Étkezési menük), ezért napot sem lehet majd rendelni.
        </ion-note>

        <div style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap">
          <ion-button color="success" (click)="belepes()">
            <ion-icon slot="start" name="log-in-outline"></ion-icon>
            Belépés (ettől a naptól étkezik)
          </ion-button>
          <ion-button color="warning" (click)="kilepes()">
            <ion-icon slot="start" name="log-out-outline"></ion-icon>
            Kilépés (ettől a naptól nem étkezik)
          </ion-button>
        </div>
        <ion-note color="medium" style="display:block;margin-top:12px;font-size:12px">
          A be-/kilépés a határidő-szabály szerint módosítható ({{sajatIntezmeny.zaras_etkezes}} nappal hamarabb
          {{sajatIntezmeny.zaras_etkezes_ora}}:00-ig), admin korlátozás nélkül. A kilépés dátumától (azt is beleértve)
          a megrendelt napok automatikusan lemondásra kerülnek: a még nem számlázott napok törlődnek, a már
          kiszámlázottakról pedig módosító (helyesbítő) számla készül, hogy csak a fennmaradó napokat kelljen fizetni.
          Új belépéssel bármikor vissza lehet térni.
        </ion-note>
      </ion-content>
    </ng-template>
  </ion-modal>

</ion-content>